<template>
    <div class="configurator__selected">
        <div class="c-selected">
            <div class="c-selected__title">Выбранная конфигурация</div>
            <div class="c-selected__list">
                <configurator-selected-item v-show="moduleConfigurator.steps[index-1] ? moduleConfigurator.steps[index-1].showNext : true"
                                            v-for="(step, index) in moduleConfigurator.steps"
                                            :indexProp="index + 1" :stepProp="step" :key="index"></configurator-selected-item>
            </div>
            <button class="c-selected__btn btn btn--middle" :disabled="moduleConfigurator.steps.length < 3"
                    @click="CLEAR_ALL">Сброс выбранных настроек
            </button>
            <button class="c-selected__btn btn btn--middle" :disabled="canConfirm"
                    @click="SET_STEPS">Подтвердить конфигурацию
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ConfiguratorSelectedItem from "@/components/Configurator/ConfiguratorSelectedItem";

export default {
    name      : "SelectedConfiguration",
    components: {ConfiguratorSelectedItem},
    computed  : {
        ... mapState(['moduleConfigurator']),
        canConfirm() {
            let er = false;
            this.moduleConfigurator.steps.forEach(item => {
                if(!item.showNext)
                    er = true;
            });
            return er;
        }
    },
    methods   : {
        ... mapActions([
            'SET_STEPS', 'CLEAR_ALL'
        ]),
    },
}
</script>

<style scoped>

</style>